module.exports = __webpack_public_path__ + "static/media/recycle.9977762c.svg";